import "./index.css";
// src/TipCard/TipCard.tsx
import { useCallback, useEffect, useRef, useState } from "react";

// ../../node_modules/motion/dist/es/motion-utils/dist/es/noop.mjs
var noop = /* @__NO_SIDE_EFFECTS__ */ (any) => any;

// ../../node_modules/motion/dist/es/motion-utils/dist/es/errors.mjs
var warning = noop;
var invariant = noop;
if (true) {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/motion/dist/es/motion-utils/dist/es/memo.mjs
// @__NO_SIDE_EFFECTS__
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var supportsScrollTimeline = memo(() => window.ScrollTimeline !== void 0);

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/controls/BaseGroup.mjs
var BaseGroupPlaybackControls = class {
  constructor(animations) {
    this.stop = () => this.runAll("stop");
    this.animations = animations.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((animation) => "finished" in animation ? animation.finished : animation));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline, fallback) {
    const subscriptions = this.animations.map((animation) => {
      if (supportsScrollTimeline() && animation.attachTimeline) {
        return animation.attachTimeline(timeline);
      } else if (typeof fallback === "function") {
        return fallback(animation);
      }
    });
    return () => {
      subscriptions.forEach((cancel, i) => {
        cancel && cancel();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(time) {
    this.setAll("time", time);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(speed) {
    this.setAll("speed", speed);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let max = 0;
    for (let i = 0; i < this.animations.length; i++) {
      max = Math.max(max, this.animations[i].duration);
    }
    return max;
  }
  runAll(methodName) {
    this.animations.forEach((controls) => controls[methodName]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/controls/Group.mjs
var GroupPlaybackControls = class extends BaseGroupPlaybackControls {
  then(onResolve, onReject) {
    return Promise.all(this.animations).then(onResolve).catch(onReject);
  }
};

// ../../node_modules/motion/dist/es/motion-utils/dist/es/progress.mjs
var progress = /* @__NO_SIDE_EFFECTS__ */ (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/motion/dist/es/motion-utils/dist/es/time-conversion.mjs
var secondsToMilliseconds = /* @__NO_SIDE_EFFECTS__ */ (seconds) => seconds * 1e3;
var millisecondsToSeconds = /* @__NO_SIDE_EFFECTS__ */ (milliseconds) => milliseconds / 1e3;

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/calc-duration.mjs
var maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state2 = generator.next(duration);
  while (!state2.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state2 = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/create-generator-easing.mjs
function createGeneratorEasing(options, scale = 100, createGenerator) {
  const generator = createGenerator({ ...options, keyframes: [0, scale] });
  const duration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
  return {
    type: "keyframes",
    ease: (progress2) => {
      return generator.next(duration * progress2).value / scale;
    },
    duration: millisecondsToSeconds(duration)
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function isGenerator(type) {
  return typeof type === "function";
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/resolve-elements.mjs
function resolveElements(elementOrSelector, scope, selectorCache) {
  var _a;
  if (elementOrSelector instanceof Element) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === "string") {
    let root = document;
    if (scope) {
      root = scope.current;
    }
    const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }
  return Array.from(elementOrSelector);
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function getValueTransition(transition, key) {
  return transition ? transition[key] || transition["default"] || transition : void 0;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/attach-timeline.mjs
function attachTimeline(animation, timeline) {
  animation.timeline = timeline;
  animation.onfinish = null;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/NativeAnimationControls.mjs
var NativeAnimationControls = class {
  constructor(animation) {
    this.animation = animation;
  }
  get duration() {
    var _a, _b, _c;
    const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
    return millisecondsToSeconds(Number(durationInMs));
  }
  get time() {
    var _a;
    if (this.animation) {
      return millisecondsToSeconds(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
    }
    return 0;
  }
  set time(newTime) {
    if (this.animation) {
      this.animation.currentTime = secondsToMilliseconds(newTime);
    }
  }
  get speed() {
    return this.animation ? this.animation.playbackRate : 1;
  }
  set speed(newSpeed) {
    if (this.animation) {
      this.animation.playbackRate = newSpeed;
    }
  }
  get state() {
    return this.animation ? this.animation.playState : "finished";
  }
  get startTime() {
    return this.animation ? this.animation.startTime : null;
  }
  get finished() {
    return this.animation ? this.animation.finished : Promise.resolve();
  }
  play() {
    this.animation && this.animation.play();
  }
  pause() {
    this.animation && this.animation.pause();
  }
  stop() {
    if (!this.animation || this.state === "idle" || this.state === "finished") {
      return;
    }
    if (this.animation.commitStyles) {
      this.animation.commitStyles();
    }
    this.cancel();
  }
  flatten() {
    var _a;
    if (!this.animation)
      return;
    (_a = this.animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming({ easing: "linear" });
  }
  attachTimeline(timeline) {
    if (this.animation)
      attachTimeline(this.animation, timeline);
    return noop;
  }
  complete() {
    this.animation && this.animation.finish();
  }
  cancel() {
    try {
      this.animation && this.animation.cancel();
    } catch (e) {
    }
  }
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/flags.mjs
var supportsFlags = {
  linearEasing: void 0
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/memo.mjs
function memoSupports(callback, supportsFlag) {
  const memoized = memo(callback);
  return () => {
    var _a;
    return (_a = supportsFlags[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/linear-easing.mjs
var supportsLinearEasing = /* @__PURE__ */ memoSupports(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch (e) {
    return false;
  }
  return true;
}, "linearEasing");

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/is-bezier-definition.mjs
var isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/linear.mjs
var generateLinearEasing = (easing, duration, resolution = 10) => {
  let points = "";
  const numPoints = Math.max(Math.round(duration / resolution), 2);
  for (let i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }
  return `linear(${points.substring(0, points.length - 2)})`;
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/easing.mjs
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing, duration) {
  if (!easing) {
    return void 0;
  } else if (typeof easing === "function" && supportsLinearEasing()) {
    return generateLinearEasing(easing, duration);
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
  } else {
    return supportedWaapiEasing[easing];
  }
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/index.mjs
function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeInOut", times } = {}) {
  const keyframeOptions = { [valueName]: keyframes };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease, duration);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/value/types/numbers/units.mjs
var createUnitType = (unit) => ({
  test: (v) => typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
var percent = /* @__PURE__ */ createUnitType("%");
var px = /* @__PURE__ */ createUnitType("px");
var progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/render/dom/value-types/number-browser.mjs
var browserNumberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Misc
  backgroundPositionX: px,
  backgroundPositionY: px
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
var isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe) {
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === void 0 ? resolvedKeyframes[index] : finalKeyframe;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/style.mjs
function setCSSVar(element, name, value) {
  element.style.setProperty(`--${name}`, value);
}
function setStyle(element, name, value) {
  element.style[name] = value;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/supports-partial-keyframes.mjs
var supportsPartialKeyframes = /* @__PURE__ */ memo(() => {
  try {
    document.createElement("div").animate({ opacity: [1] });
  } catch (e) {
    return false;
  }
  return true;
});

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/supports-waapi.mjs
var supportsWaapi = /* @__PURE__ */ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/NativeAnimation.mjs
var state = /* @__PURE__ */ new WeakMap();
function hydrateKeyframes(valueName, keyframes, read) {
  for (let i = 0; i < keyframes.length; i++) {
    if (keyframes[i] === null) {
      keyframes[i] = i === 0 ? read() : keyframes[i - 1];
    }
    if (typeof keyframes[i] === "number" && browserNumberValueTypes[valueName]) {
      keyframes[i] = browserNumberValueTypes[valueName].transform(keyframes[i]);
    }
  }
  if (!supportsPartialKeyframes() && keyframes.length < 2) {
    keyframes.unshift(read());
  }
}
var defaultEasing = "easeOut";
function getElementAnimationState(element) {
  const animationState = state.get(element) || /* @__PURE__ */ new Map();
  state.set(element, animationState);
  return state.get(element);
}
var NativeAnimation = class extends NativeAnimationControls {
  constructor(element, valueName, valueKeyframes, options) {
    const isCSSVar = valueName.startsWith("--");
    invariant(typeof options.type !== "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "framer-motion"?`);
    const existingAnimation = getElementAnimationState(element).get(valueName);
    existingAnimation && existingAnimation.stop();
    const readInitialKeyframe = () => {
      return valueName.startsWith("--") ? element.style.getPropertyValue(valueName) : window.getComputedStyle(element)[valueName];
    };
    if (!Array.isArray(valueKeyframes)) {
      valueKeyframes = [valueKeyframes];
    }
    hydrateKeyframes(valueName, valueKeyframes, readInitialKeyframe);
    if (isGenerator(options.type)) {
      const generatorOptions = createGeneratorEasing(options, 100, options.type);
      options.ease = supportsLinearEasing() ? generatorOptions.ease : defaultEasing;
      options.duration = secondsToMilliseconds(generatorOptions.duration);
      options.type = "keyframes";
    } else {
      options.ease = options.ease || defaultEasing;
    }
    const onFinish = () => {
      this.setValue(element, valueName, getFinalKeyframe(valueKeyframes, options));
      this.cancel();
      this.resolveFinishedPromise();
    };
    const init = () => {
      this.setValue = isCSSVar ? setCSSVar : setStyle;
      this.options = options;
      this.updateFinishedPromise();
      this.removeAnimation = () => {
        const elementState = state.get(element);
        elementState && elementState.delete(valueName);
      };
    };
    if (!supportsWaapi()) {
      super();
      init();
      onFinish();
    } else {
      super(startWaapiAnimation(element, valueName, valueKeyframes, options));
      init();
      if (options.autoplay === false) {
        this.animation.pause();
      }
      this.animation.onfinish = onFinish;
      getElementAnimationState(element).set(valueName, this);
    }
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((resolve) => {
      this.resolveFinishedPromise = resolve;
    });
  }
  play() {
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    super.play();
  }
  cancel() {
    this.removeAnimation();
    super.cancel();
  }
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/animate-elements.mjs
function animateElements(elementOrSelector, keyframes, options, scope) {
  const elements = resolveElements(elementOrSelector, scope);
  const numElements = elements.length;
  invariant(Boolean(numElements), "No valid element provided.");
  const animations = [];
  for (let i = 0; i < numElements; i++) {
    const element = elements[i];
    const elementTransition = { ...options };
    if (typeof elementTransition.delay === "function") {
      elementTransition.delay = elementTransition.delay(i, numElements);
    }
    for (const valueName in keyframes) {
      const valueKeyframes = keyframes[valueName];
      const valueOptions = {
        ...getValueTransition(elementTransition, valueName)
      };
      valueOptions.duration = valueOptions.duration ? secondsToMilliseconds(valueOptions.duration) : valueOptions.duration;
      valueOptions.delay = secondsToMilliseconds(valueOptions.delay || 0);
      animations.push(new NativeAnimation(element, valueName, valueKeyframes, valueOptions));
    }
  }
  return animations;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/animate-style.mjs
var createScopedWaapiAnimate = (scope) => {
  function scopedAnimate(elementOrSelector, keyframes, options) {
    return new GroupPlaybackControls(animateElements(elementOrSelector, keyframes, options, scope));
  }
  return scopedAnimate;
};
var animateMini = /* @__PURE__ */ createScopedWaapiAnimate();

// src/TipCard/TipCard.module.scss
var TipCard_module_default = {
  tipCard: "TipCard_module_tipCard",
  clickable: "TipCard_module_clickable",
  backgroundLayer: "TipCard_module_backgroundLayer",
  content: "TipCard_module_content",
  label: "TipCard_module_label",
  title: "TipCard_module_title",
  description: "TipCard_module_description",
  navigation: "TipCard_module_navigation",
  nextButton: "TipCard_module_nextButton",
  skyBluePurple: "TipCard_module_skyBluePurple",
  coralMagenta: "TipCard_module_coralMagenta",
  aquaPurple: "TipCard_module_aquaPurple",
  pinkLavender: "TipCard_module_pinkLavender",
  pastelPurplePink: "TipCard_module_pastelPurplePink",
  peachLavender: "TipCard_module_peachLavender",
  periwinkleBlue: "TipCard_module_periwinkleBlue",
  sunsetPinkCyan: "TipCard_module_sunsetPinkCyan"
};

// src/TipCard/TipCard.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_AUTO_ROTATE_INTERVAL = 5e3;
var gradientClassMap = {
  skyBluePurple: TipCard_module_default.skyBluePurple,
  coralMagenta: TipCard_module_default.coralMagenta,
  aquaPurple: TipCard_module_default.aquaPurple,
  pinkLavender: TipCard_module_default.pinkLavender,
  pastelPurplePink: TipCard_module_default.pastelPurplePink,
  peachLavender: TipCard_module_default.peachLavender,
  periwinkleBlue: TipCard_module_default.periwinkleBlue,
  sunsetPinkCyan: TipCard_module_default.sunsetPinkCyan
};
var TipCard = ({ tips, autoRotateInterval = DEFAULT_AUTO_ROTATE_INTERVAL, onNext, onTipClick }) => {
  const [currentIndex, setCurrentIndex] = useState(() => tips.length > 0 ? Math.floor(Math.random() * tips.length) : 0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);
  const contentRef = useRef(null);
  const bgCurrentRef = useRef(null);
  const bgNextRef = useRef(null);
  const cardRef = useRef(null);
  const isAnimatingRef = useRef(false);
  const hasMountedRef = useRef(false);
  useEffect(() => {
    if (cardRef.current && !hasMountedRef.current) {
      hasMountedRef.current = true;
      cardRef.current.style.opacity = "0";
      animateMini(cardRef.current, { opacity: 1 }, { duration: 0.4, ease: "easeOut" });
    }
  }, []);
  const advanceToNext = useCallback(() => {
    if (isAnimatingRef.current)
      return;
    const newIndex = (currentIndex + 1) % tips.length;
    if (contentRef.current && bgCurrentRef.current && bgNextRef.current) {
      isAnimatingRef.current = true;
      const nextGradientClass = gradientClassMap[tips[newIndex].gradientVariant];
      bgNextRef.current.className = `${TipCard_module_default.backgroundLayer} ${nextGradientClass}`;
      bgNextRef.current.style.opacity = "0";
      Promise.all([
        animateMini(contentRef.current, { opacity: 0, transform: "translateX(-12px)" }, { duration: 0.25, ease: "easeOut" }),
        animateMini(bgCurrentRef.current, { opacity: 0 }, { duration: 0.3, ease: "easeOut" }),
        animateMini(bgNextRef.current, { opacity: 1 }, { duration: 0.3, ease: "easeOut" })
      ]).then(() => {
        if (!bgCurrentRef.current || !bgNextRef.current) {
          isAnimatingRef.current = false;
          return;
        }
        const currentGradientClass = gradientClassMap[tips[newIndex].gradientVariant];
        bgCurrentRef.current.className = `${TipCard_module_default.backgroundLayer} ${currentGradientClass}`;
        bgCurrentRef.current.style.opacity = "1";
        bgNextRef.current.style.opacity = "0";
        setCurrentIndex(newIndex);
        onNext?.(newIndex);
        if (contentRef.current) {
          contentRef.current.style.transform = "translateX(12px)";
          contentRef.current.style.opacity = "0";
          animateMini(contentRef.current, { opacity: 1, transform: "translateX(0px)" }, { duration: 0.3, ease: "easeOut" }).then(() => {
            if (contentRef.current) {
              contentRef.current.style.transform = "";
            }
            isAnimatingRef.current = false;
          });
        } else {
          isAnimatingRef.current = false;
        }
      });
    } else {
      setCurrentIndex(newIndex);
      onNext?.(newIndex);
    }
  }, [currentIndex, tips, onNext]);
  const resetInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    if (!isPaused && tips.length > 1) {
      intervalRef.current = setInterval(advanceToNext, autoRotateInterval);
    }
  }, [isPaused, tips.length, advanceToNext, autoRotateInterval]);
  useEffect(() => {
    resetInterval();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [resetInterval]);
  const handleNextClick = () => {
    advanceToNext();
    resetInterval();
  };
  const handleMouseEnter = () => {
    setIsPaused(true);
  };
  const handleMouseLeave = () => {
    setIsPaused(false);
  };
  const handleCardClick = () => {
    onTipClick?.(currentIndex);
  };
  if (tips.length === 0) {
    return null;
  }
  const currentTip = tips[currentIndex];
  const gradientClass = gradientClassMap[currentTip.gradientVariant];
  const isClickable = !!onTipClick;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: cardRef,
      className: `${TipCard_module_default.tipCard} ${isClickable ? TipCard_module_default.clickable : ""}`,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onClick: isClickable ? handleCardClick : void 0,
      role: isClickable ? "button" : void 0,
      tabIndex: isClickable ? 0 : void 0,
      onKeyDown: isClickable ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardClick();
        }
      } : void 0,
      children: [
        /* @__PURE__ */ jsx("div", { ref: bgCurrentRef, className: `${TipCard_module_default.backgroundLayer} ${gradientClass}` }),
        /* @__PURE__ */ jsx("div", { ref: bgNextRef, className: TipCard_module_default.backgroundLayer, style: { opacity: 0 } }),
        /* @__PURE__ */ jsxs("div", { ref: contentRef, className: TipCard_module_default.content, children: [
          currentTip.label && /* @__PURE__ */ jsx("div", { className: TipCard_module_default.label, children: currentTip.label }),
          /* @__PURE__ */ jsx("div", { className: TipCard_module_default.title, children: currentTip.title }),
          /* @__PURE__ */ jsx("div", { className: TipCard_module_default.description, children: currentTip.description })
        ] }),
        tips.length > 1 && /* @__PURE__ */ jsx("div", { className: TipCard_module_default.navigation, children: /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: TipCard_module_default.nextButton,
            onClick: (e) => {
              e.stopPropagation();
              handleNextClick();
            },
            children: "Next"
          }
        ) })
      ]
    }
  );
};

// src/TipCard/useTipCardTimer.ts
import { useCallback as useCallback2, useEffect as useEffect2, useRef as useRef2, useState as useState2 } from "react";
var useTipCardTimer = ({ delayMs = 8e3, enabled = true } = {}) => {
  const [showIdleState, setShowIdleState] = useState2(false);
  const lastResetTime = useRef2(Date.now());
  const intervalRef = useRef2(null);
  const resetTimer = useCallback2(() => {
    lastResetTime.current = Date.now();
    setShowIdleState(false);
  }, []);
  useEffect2(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (!enabled) {
      setShowIdleState(false);
      return;
    }
    const checkIdleState = () => {
      const timeSinceReset = Date.now() - lastResetTime.current;
      if (timeSinceReset >= delayMs) {
        setShowIdleState(true);
      }
    };
    checkIdleState();
    intervalRef.current = setInterval(checkIdleState, 1e3);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [enabled, delayMs]);
  return { showIdleState, resetTimer };
};

// src/TipCard/tips.ts
var AWS_MARKETPLACE_TIPS = [
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Skip vendor onboarding",
    description: "Use your existing AWS relationship.",
    gradientVariant: "skyBluePurple"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Speed up legal reviews",
    description: "With AWS Marketplace standard contract. Review once and reuse.",
    gradientVariant: "coralMagenta"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Try before you commit",
    description: "With free trials and pay-as-you-go pricing.",
    gradientVariant: "aquaPurple"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Find products that run on AWS",
    description: 'Try "Show only products deployed on AWS."',
    gradientVariant: "pinkLavender"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Get the most from your money",
    description: "Find savings with all your AWS Marketplace purchases in one place.",
    gradientVariant: "pastelPurplePink"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "One bill, all your purchases",
    description: "Save your accountants the headache.",
    gradientVariant: "peachLavender"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Quick Launch SaaS products",
    description: "Get secure, automated SaaS deployments with AWS CloudFormation.",
    gradientVariant: "periwinkleBlue"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "No unused licenses",
    description: "Share AWS Marketplace licenses across accounts with AWS License Manager.",
    gradientVariant: "sunsetPinkCyan"
  },
  {
    label: "BUY WITH AWS MARKETPLACE",
    title: "Skip payment setup",
    description: "Use your existing secure AWS payment methods.",
    gradientVariant: "skyBluePurple"
  }
];
export {
  AWS_MARKETPLACE_TIPS,
  TipCard,
  useTipCardTimer
};
//# sourceMappingURL=index.js.map
